module.exports = __webpack_public_path__ + "static/media/icon-area.d1d32354.svg";